export default "__VITE_ASSET__BwN6N25z__"